<style lang="less">
.img-star {
  color: #f56c6c;
  margin: 12px -76px 0px 40px;
}
.hide .el-upload--picture-card {
  display: none;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form
          :model="detailForm"
          :rules="pageConfig.formRules"
          ref="detailForm"
          label-width="120px"
          class="detail-form"
        >
          <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <div class="flex">
                <div class="img-star">*</div>
                <el-form-item label="图片">
                  <el-upload
                    :class="{ hide: hideUpload }"
                    action=""
                    :http-request="toUploadImg"
                    list-type="picture-card"
                    :limit="1"
                    :on-remove="handleImgRemove"
                    :before-upload="beforeAvatarUpload"
                    :on-preview="handlePictureCardPreview"
                    :file-list="image"
                  >
                    <i class="el-icon-plus"></i>
                    <div slot="tip" class="el-upload__tip">
                      (只能上传一张图片,且不得超过1MB!)
                    </div>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="" />
                  </el-dialog>
                </el-form-item>
              </div>
              <el-form-item label="通知跳转" prop="bannerUrl">
                <el-input
                  v-model="detailForm.bannerUrl"
                  size="small"
                ></el-input>
              </el-form-item>
              <el-form-item label="应用app" prop="affiliationType">
                <el-select
                  class="full-width"
                  v-model="detailForm.affiliationType"
                  size="small"
                >
                  <el-option
                    v-for="item in applist"
                    :label="item.configName"
                    :value="item.configVal"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="flex-1"></div>
          </div>
        </el-form>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig,
      editFlag: false,
      pageTitle: 'banner编辑',
      // 默认值设置
      detailForm: {
        bannerType: '03',
        bannerStatus: 'OFF',
        bannerStatusName: '关闭',
      },
      image: [],//图片储存
      dialogVisible: false,//图片弹窗
      dialogImageUrl: null,//图片地址
      picPath: null,//图片file文件
      hideUpload: false,//上传图片按钮
      applist: [],//应用app列表
    }
  },
  methods: {
      //判断是否为编辑模式,
    init() {
      // if(this.$store.state.editId){
      //     this.editFlag = true;
      //     this.getFormInfo();
      //     this.detailForm = this.$store.state.bannerObj;
      //     if(this.detailForm.picPath){
      //         let imgObj = {};
      //         imgObj.url = this.detailForm.picPath
      //         this.image.push(imgObj);
      //         this.hideUpload = true;
      //     }
      // }
      if (this.$route.query.editId) {
        this.editFlag = true
        this.detailForm = this.$store.state.bannerObj
        if (this.detailForm.picPath) {
          let imgObj = {}
          imgObj.url = this.detailForm.picPath
          this.image.push(imgObj)
          this.hideUpload = true
        }
      }
    },
    //获取app 列表
    getFormInfo() {
      let _ = this
      _.$H.post(_, _.$A.config.list, { configType: '213' }).then((res) => {
        _.applist = res.data.data
      })
    },
    //上传图片
    toUploadImg(param) {
      this.picPath = param.file
      this.hideUpload = true
    },
    //删除图片
    handleImgRemove(file) {
      this.picPath = null
      this.image = []
      this.hideUpload = false
    },
    //查看图片大图
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片大小限制
    beforeAvatarUpload(file) {
      const isLt200K = file.size / 1024 / 1024 < 1

      if (!isLt200K) {
        this.$U.error('上传广告图片大小不能超过 1MB!')
      }
      return isLt200K
    },
    // 表单提交
    submitForm(formName) {
      let _ = this
      if (_.picPath == null && _.image.length == 0) {
        _.$U.error('请上传banner图片')
        return
      }
      _.detailForm.corpNo = _.$store.state.corpNo
      let formData = new FormData()
      Object.keys(_.detailForm).forEach((key) => {
        formData.append(key, _.detailForm[key])
      })
      formData.append('file', _.picPath)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$S.submitForm(
            _,
            _.$A.mobile.banner,
            _.editFlag,
            formData,
            pageConfig.listRouter
          )
        }
      })
    },
    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.listRouter,
      })
    },
  },
  mounted() {
    this.init()
    this.getFormInfo()
  },
}
</script>
